var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"d-flex flex-fill fill-height justify-center align-center",attrs:{"flat":""}},[(_vm.loading)?_c('v-progress-circular',{attrs:{"size":_vm.size,"width":_vm.width,"color":"grey","indeterminate":""}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }